<template>
  <el-form ref="form" label-width="160px" :rules="rules" :model="dioForm">
    <div class="iconClass" v-show="editObj">
      <i class="el-icon-back" :title="$t('public.mode_view')" @click="lookFn"></i>
    </div>
    <div class="content" v-loading="loading">
      <div class="leftContent">
        <template v-if="$store.state.type === 3 || $store.state.type === 2">
          <el-form-item :label="$t('account_redesign.company')" prop="customerId" v-if="!isProxyType">
            <el-select v-model="dioForm.customerId" style="width: 250px" @change="changeCustomer">
              <el-option v-for="item in customerArray" :key="item.id" :value="item.id" :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item :label="$t('user.proxy_customer')" prop="customerIds" v-if="isProxyType" :rules="[
          {
            required: isProxyType,
            validator: proxyCheck,
            trigger: 'change',
          },
        ]">
          <div style="max-height: 200px;overflow:auto;">
            <div v-for="(item, index) in customerIdArray" :key="index" class="proxyClass">
              <el-select v-model="item.customerIds" style="width: 250px" @change="ProxyChange">
                <el-option v-for="item in customerArray" :disabled="item.disabled" :key="item.id" :value="item.id"
                  :label="item.name"></el-option>
              </el-select>
              <i class="el-icon-plus" :title="$t('public.btn_add')" @click="addProxy(index)"></i>
              <i class="el-icon-delete" :title="$t('public.btn_delete')" @click="delProxy(item, index)"></i>
            </div>
          </div>

        </el-form-item>
        <el-form-item :label="$t('user.role_name')" prop="name">
          <el-input v-model.trim="dioForm.name" style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('user.remarks')" prop="remark">
          <el-input v-model.trim="dioForm.remark" style="width: 250px" type="textarea" maxlength="250"
            :autosize="{ minRows: 4, maxRows: 6 }" show-word-limit :placeholder="$t('public.please_enter')" />
        </el-form-item>
      </div>
      <div class="rightContent">
        <el-form-item :label="$t('user.resource')" prop="page" :rules="[
          {
            required: isEdit,
            validator: treeCheck,
            trigger: 'blur',
          },
        ]">
          <div class="treeClass" v-loading="loading">
            <el-tree :key="$i18n.locale" :props="props" :data="StructureArray" :show-checkbox="isEdit" :render-content="renderContent"
              @check-change="handleCheckChange" ref="tree" node-key="functionCode" :default-checked-keys="defaultKeys"
              :default-expanded-keys="defaultKeys">
            </el-tree>
          </div>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { roleResource, roleCustomer } from '@/api/modules/role.js'
export default {
  props: [
    'statusArray',
    'roleTypeArray',
    'customerAddArray',
    'editObj',
    'ismode',
    'editTree',
    'treeLoading',
  ],
  computed: {
    rules() {
      return {
        name: [
          { required: true, message: this.$t("validate.user_name_required"), trigger: 'blur' },
          {
            max: 50,
            message: this.$t("validate.len_50"),
            trigger: 'blur',
          },
        ],
      }
    },
    isShowDialog: {
      get: function () {
        return this.ismode
      },
      set: function (val) {
        this.$emit('update:ismode', val) //可以优化成model  或者minx
      },
    },
  },
  watch: {
    treeLoading(newVal) {
      this.loading = newVal
    },
    editTree(newVal) {
      this.defaultKeys = []
      let newArray = []
      this.defaultKeys = this.TODODEEPTREE([...newVal], newArray)
      this.StructureArray = [...newVal]
    },

    customerAddArray(newVal) {
      if (newVal.length > 0) {

        newVal.forEach((item) => {
          (this.customerIdArray || []).forEach((opt) => {
            if (item.id === opt.customerIds) {
              this.$set(item, 'disabled', true)
            }
          })
        })
        this.customerArray = [...newVal]
      }
    },
    editObj(newVal) {
      // 是否为代理
      if (newVal.type === -1) {
        this.isProxyType = true
        this.customerIdArray = { ...newVal }.proxy.map((item) => ({
          customerIds: item.id,
        }))
      } else {
        this.isProxyType = false
      }

      // type 0 或 2 都可勾选 tree
      this.isEdit = true

      this.dioForm = { ...newVal }

      // 根据customerId自动设置type：V-mark(id==1)→2，其他→0
      this.dioForm.type = this.calcRoleType(this.dioForm.customerId)
      // status 默认1
      if (!this.dioForm.status) {
        this.dioForm.status = 1
      }

      this.dioForm.page = []
      this.dioForm.func = []
    },
    '$i18n.locale'() {
      // 切换语言时保留当前勾选状态，:key="$i18n.locale" 会强制 el-tree 重新渲染
      if (this.isEdit && this.$refs.tree) {
        this.defaultKeys = this.$refs.tree.getCheckedKeys();
      }
    },
  },
  data() {
    return {
      islookMode: false,
      dioForm: {
        customerId: '',
        name: '',
        remark: '',
        status: '',
        type: '',
        customerIds: '',
        page: '',
        func: '',
      },
      // 回选树
      defaultKeys: [],
      customerIdArray: [
        {
          customerIds: '',
        },
      ],
      // 客户
      customerArray: [],
      // 是否为代理
      isProxyType: false,
      // 是否可勾选tree
      isEdit: false,
      StructureArray: [],
      props: {
        label: 'label',
        children: 'item',
      },
      loading: false,
      lastScopeId: null,
      treeRenderKey: 0,
    }
  },
  mounted() { },
  methods: {
    /** 递归遍历树获取选中的id */
    TODODEEPTREE(array = [], newArray) {
      array.forEach((option) => {
        if (option.level === 3 && option.check === 2) {
          newArray.push(option.functionCode)
        } else {
          if (option.item && option.item.length > 0) {
            this.TODODEEPTREE(option.item, newArray)
          }
        }
      })
      return newArray
    },
    concatFn() {
      this.$emit('concatFn')
    },
    lookFn() {
      this.isShowDialog = !this.isShowDialog
    },
    proxyCheck(rule, value, callback) {
      let flag = true

      for (let item of this.customerIdArray) {
        if (item.customerIds === '') {
          flag = false
          break
        }
      }
      if (!flag) {
        callback(this.$t("validate.user_proxy_customer_required"))
      } else {
        callback()
      }
    },
    resetInitData() {
      this.clearValidate()
      // status 默认1
      this.dioForm.status = 1
      if (!this.editObj) {
        // 区分编辑
        this.dioForm.customerId = this.customerAddArray[0].id
      }
      // 根据customerId自动设置type：V-mark(id==1)→2，其他→0
      this.dioForm.type = this.calcRoleType(this.dioForm.customerId)
      // type 0 或 2 都可勾选 tree
      this.isEdit = true
      this.isProxyType = false
      this.getRoleTreeFn(this.customerArray[0].scopeId)
    },
    /** 根据customerId计算role type：V-mark(id==1)→2，其他→0 */
    calcRoleType(customerId) {
      return (String(customerId) === '1') ? 2 : 0
    },
    clearValidate() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    addProxy() {
      this.customerIdArray.push({
        customerIds: '',
      })
    },
    delProxy(row, index) {
      if (this.customerIdArray.length === 1)
        return this.$message.warning(this.$t('user.tip_least_reain_one_data'))
      this.customerIdArray.splice(index, 1)

      if (row.customerIds === '') return

      this.customerArray.forEach((item) => {
        if (row.customerIds === item.id) {
          this.$set(item, 'disabled', false)
        }
      })
    },
    ProxyChange(id) {
      const cusArray = this.customerIdArray.map(item => item.customerIds);
      const array = [id, ...cusArray]
      this.customerArray.forEach((item) => {
        array.includes(item.id) ? this.$set(item, 'disabled', true) : this.$set(item, 'disabled', false)
      })
    },
    async justify() {
      try {
        return await this.$refs['form'].validate()
      } catch (error) {
        return false
      }
    },
    // 客户切换
    changeCustomer(id) {
      // 根据customerId自动设置type：V-mark(id==1)→2，其他→0
      this.dioForm.type = this.calcRoleType(id)
      let scopeId;
      for (let item of this.customerArray) {
        if (item.id === id) {
          scopeId = item.scopeId;
          break
        }
      }
      this.getRoleTreeFn(scopeId)
    },
    getroleCustomerFn(typeId) {
      return new Promise((resolve, reject) => {
        roleCustomer({ type: typeId }).then(({ result }) => {
          this.customerArray = result
          this.dioForm.customerId = result[0].id;
          resolve(true)
        })
      })
    },
    getRoleTreeFn(scopeId) {
      this.loading = true;
      this.lastScopeId = scopeId;
      let query = {
        id: this.dioForm.id || null,
        type: this.dioForm.type,
        isEdit: 1,
        scopeId: !this.isProxyType && scopeId || null
      }
      roleResource(query)
        .then(({ result }) => {
          this.StructureArray = result.item || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    treeCheck(rule, value, callback) {
      this.choozeTree()
      if (
        (this.dioForm.type === 0 || this.dioForm.type === 2) &&
        this.dioForm.page.length === 0
      ) {
        callback(this.$t("validate.user_operable_resource_required"))
      } else {
        callback()
      }
    },
    handleCheckChange() {
      this.choozeTree()
    },

    choozeTree() {
      let HalfCheckedNode = this.$refs['tree'].getHalfCheckedNodes()
      let CheckedNodes = this.$refs['tree'].getCheckedNodes()
      // 半选状态
      let pageIdArray = []
      let FuncALLArray = []
      HalfCheckedNode.forEach((item) => {
        if (item.level === 1 || item.level === 2) {
          pageIdArray.push(item.pageId)
        }
      })

      // 全选
      CheckedNodes.forEach((item) => {
        if (item.level === 1 || item.level === 2) {
          pageIdArray.push(item.pageId)
        }
      })
      CheckedNodes.forEach((item) => {
        if (item.level === 3) {
          FuncALLArray.push(item.functionCode)
        }
      })

      this.dioForm.page = [...pageIdArray]
      this.dioForm.func = [...FuncALLArray]
    },

    renderContent() {
      let createElement = arguments[0]
      let data = arguments[1].data
      let isZh = (this.$i18n.locale || '').indexOf('zh') === 0
      // 动态菜单节点直接使用 DB 中的本地化名称，兜底到 label（code）
      let displayName = isZh ? (data.nameZh || data.label) : (data.nameEn || data.label)
      return createElement('span', displayName)
    },
  },
}
</script>

<style lang="scss" scoped>
.iconClass {
  height: 30px;
  line-height: 30px;
  text-align: right;

  i {
    margin: 0 5px;
    cursor: pointer;
    color: var(--primary-color);

    &:hover {
      font-size: 16px;
      font-weight: bold;
    }
  }
}

.content {
  width: 100%;
  height: 650px;
  display: flex;

  ::v-deep .el-textarea__inner {
    border-radius: 2px;
    margin-left: 5px;
  }

  .proxyClass {
    &:not(:first-child) {
      margin-top: 15px;
    }

    i {
      margin: 0 5px;
      cursor: pointer;
      font-weight: bold;
    }
  }
}

.leftContent,
.rightContent {
  flex: 1;


  .treeClass {
    height: 600px;
    overflow: auto;
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    border: 1px solid #e7e7e7;
  }
}
</style>